import React from 'react';
import type { StageStatus } from './types';

// COLORS
// COLORS
const STATUS_COLORS: Record<StageStatus, string> = {
    ready: '#4caf50',     // Green (Complete)
    ok: '#4caf50',        // Legacy Map -> Green
    incomplete: '#ff9800',// Orange (Missing critical)
    miss_some: '#ffca28', // Yellow (Missing non-critical)
    missing: '#ff9800',   // Legacy Map -> Orange
    broken: '#f44336',    // Red
    running: '#2196f3',   // Blue
    queued: '#9c27b0',    // Purple
    pending: '#757575',   // Grey
    unknown: '#607d8b'    // BlueGrey
};

// ACTIONS (Using simple text indicators for now)
const STATUS_ICONS: Record<StageStatus, string> = {
    ready: '✓',
    ok: '✓',
    incomplete: '!',
    miss_some: '!',
    missing: '!',
    broken: 'X',
    running: '▶',
    queued: 'Q',
    pending: '?',
    unknown: '?'
};

export const StatusBadge = ({ status, label }: { status: StageStatus, label?: string }) => {
    return (
        <span style={{
            backgroundColor: STATUS_COLORS[status] + '22', // 22 = low opacity hex
            color: STATUS_COLORS[status],
            border: `1px solid ${STATUS_COLORS[status]}`,
            padding: '2px 8px',
            borderRadius: '12px',
            fontSize: '11px',
            fontWeight: 'bold',
            display: 'inline-flex',
            alignItems: 'center',
            gap: '4px',
            textTransform: 'uppercase'
        }}>
            {label || status}
        </span>
    );
};

export const StageIndicator = ({ label, status, onClick }: { label: string, status: StageStatus, onClick?: () => void }) => {
    return (
        <div
            onClick={onClick}
            style={{
                display: 'flex',
                alignItems: 'center',
                gap: '6px',
                opacity: status === 'pending' ? 0.5 : 1,
                cursor: onClick ? 'pointer' : 'default'
            }}>
            <div style={{
                width: '10px',
                height: '10px',
                borderRadius: '50%',
                backgroundColor: STATUS_COLORS[status],
                boxShadow: status === 'running' ? '0 0 8px #2196f3' : 'none'
            }} />
            <span style={{ fontSize: '12px', fontWeight: 500, color: '#eee' }}>{label}</span>
        </div>
    );
};
